import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import logo from "../logoImage.png";
import { ROUTES } from "../utils/RouteConstants";
import { FeedbackReducerActionType, useFeedbackDispatch } from "../utils/FeedbackContext";
import { login } from "../api/RestCallHelper";
import { getRequest } from "../api/Api";
import FetchState from "../api/FetchState";
import LoadingIcon from "../shared/LoadingIcon";
import "./login.css";

export default function Login() {

  const location = useLocation();
  const history = useHistory();
  const dispatch = useFeedbackDispatch();

  const [isSending, setIsSending] = useState(false);
  const [fetchState, setFetchState] = useState(null);
  const [loginFailed, setLoginFailed] = useState(false);

  const [credentials, setCredentials] = useState({
    username: "",
    password: ""
  });

  const errorClose = (event, reason) => {
    if (reason === "clickaway") return;
    dispatch({ type: FeedbackReducerActionType.CLOSE_FEEDBACK });
  };

  useEffect(() => {
    getRequest("actuator/health").catch(() => {});
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSending) return;

    setIsSending(true);
    setLoginFailed(false);
    setFetchState(FetchState.LOADING);

    const success = await login(credentials, setFetchState, dispatch, errorClose, history, location);

    if (success === true) {
      if (location.state) {
        history.push(location.state.last, location.state.data);
      } else {
        history.push(ROUTES.DASHBOARD);
      }
      return;
    }

    setLoginFailed(true);
    setIsSending(false);
    setFetchState(null);
  };

  if (fetchState === FetchState.LOADING) {
    return <LoadingIcon />;
  }

  return (
      <aside className="profile-card">
        <header>
          <img src={logo} alt="logo" width="150" height="150" />

          <form className="sign-up" onSubmit={handleSubmit}>
            <input
                type="text"
                className="sign-up-input"
                placeholder="ENTER USERNAME"
                autoComplete="username"
                autoFocus
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
            />
            <input
                type="password"
                className="sign-up-input"
                placeholder="ENTER PASSWORD"
                autoComplete="current-password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            />

            <p className="sign-up-error">
              {loginFailed ? "Username or password incorrect" : ""}
            </p>

            <button type="submit" className="sign-up-button" disabled={isSending}>
              SIGN IN
            </button>
          </form>
        </header>
      </aside>
  );
}
